import React, { useEffect, useRef, useState } from "react";

import Breadcrumbs from "../../../../components/Breadcrumbs";
import { Table } from "antd";
import { Link, useLocation, useNavigate } from "react-router-dom";
import AddandEditPolicy from "../../../../components/modelpopup/AddandEditPolicy";
import DeleteModal from "../../../../components/modelpopup/deletePopup";

import {
  formatDateInTimezone,
  formatDateOnly,
  formatDateTimeInTimezone,
} from "../../../../utils/formatDateInTimezone";
import config from "./../../../../config";
import { capitalizeFirstLetter } from "../../../../utils/basicFunctions";
import UploadDocumnetModal from "../../Employees/UploadDocumnetModal";
import api from "../../../../api/axios";
import { useTranslation } from "react-i18next";
import UploadDocuments from "../../../../components/modelpopup/UploadDocuments";
import GenerateDocumentModal from "../../../../components/modelpopup/GenerateDocumentModal";
import { getEmployerDocumentTypes } from "../../../../services/uploadDocumentService";
import { companyID, getEmployeeLocalDetails } from "../../../../auth";

const UploadDocumnet = () => {
  //------------------ get all requested document ------
  const { t } = useTranslation();
  const [requestedData, setRequestedData] = useState([]);
  const [deletedID, setDeletedID] = useState("");
  const [requestedDocumnetID, setRequestedDocumnetId] = useState("");
  const [employeeID, setEmployeeID] = useState("");
  const [openUploadDocuments, setOpenUploadDocuments] = useState(false);
  const [openGenerateDocument, setOpenGenerateDocument] = useState(false);
  const [employerDocuments, setEmployerDocuments] = useState([]);
  const [employeeData, setEmployeeData] = useState([]);
  const [requestedDocument, setRequestDocument] = useState(1);

  const getAllEmployeerDocument = async () => {
    try {
      const response = await getEmployerDocumentTypes();
      setEmployerDocuments(response?.result);
    } catch (err) {
      console.log(err);
    }
  };

  const company_id = companyID();
  const employeeDetails = getEmployeeLocalDetails();
  const fetchCompanyEmployees = async (params = { status: 1 }) => {
    if (
      !employeeDetails ||
      !employeeDetails.employee_role ||
      (employeeDetails.employee_role != 1 &&
        !employeeDetails.working_departments?.length)
    ) {
      setEmployeeData([]);
      return;
    }

    try {
      let finalParams = { ...params };
      if (
        employeeDetails.employee_role != 1 &&
        employeeDetails.working_departments?.length
      ) {
        if (!("department_id" in finalParams))
          finalParams.department_id = employeeDetails.working_departments;
      }

      const queryParams = new URLSearchParams();
      Object.entries(finalParams).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach((val) => {
            if (val !== null && val !== undefined && val !== "") {
              queryParams.append(key, val);
            }
          });
        } else {
          queryParams.append(key, value);
        }
      });

      const response = await api.get(
        `employees/employeeDetails/${company_id}?${queryParams.toString()}&status=0`
      );

      if (!Array.isArray(response?.data)) {
        console.error("Invalid data format received:", response);
        setEmployeeData([]);
        return;
      }

      const filteredData = response.data.map((item) => ({
        ...item,
        first_name: item.first_name ?? "",
        middle_name: item.middle_name ?? "",
        last_name: item.last_name ?? "",
        official_email: item.official_email ?? "-",
        photo: item.photo ?? "",
        number: item.number ?? "-",
        department_id: item.department_id ?? "",
        designation_id: item.designation_id ?? "",
        department_name: item.department_name ?? "-",
        designation_name: item.designation_name ?? "-",
        employment_id: item?.employment_id,
        status: item.status,
      }));

      setEmployeeData(filteredData);
    } catch (error) {
      console.error("Error fetching company employees:", error);
      setEmployeeData([]);
    } finally {
    }
  };

  console.log("employeesData", employeeData);

  const fetchRequestedDocument = async () => {
    const employee_id = localStorage.getItem("employeeID");
    const company_id = companyID();
    const working_departments = getEmployeeLocalDetails()?.working_departments;
    const role_id = getEmployeeLocalDetails()?.employee_role;

    console.log("working_departments", working_departments);

    try {
      let url = `hr/requested-document/${employee_id}?company_id=${company_id}`;

      if (role_id == 2 && working_departments?.length > 0) {
        // add each department_id separately
        url += working_departments.map((d) => `&department_id=${d}`).join("");
      } else if (role_id != 1 && role_id != 2) {
        console.log("No API call for this role");
        return;
      }

      const request = await api.get(url);

      if (request?.data?.success === true) {
        setRequestedData(request?.data?.result);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchRequestedDocument();
    fetchCompanyEmployees();
    getAllEmployeerDocument();
  }, []);

  const documentRequest = requestedData?.map((data, index) => {
    return {
      id: index + 1,
      my_documents_id: data?.my_documents_id,
      name:
        capitalizeFirstLetter(data?.first_name) +
        " " +
        capitalizeFirstLetter(data?.middle_name) +
        " " +
        capitalizeFirstLetter(data?.last_name),
      requested_document: data?.document_name,
      status: data?.employee_document_request_status,
      employee_id: data?.employee_id,
      requested_document_id: data?.employee_request_document_id,
      document_id: data?.document_type,
      visible: data?.my_document_status,
      document: data?.document,
      document_value: data?.document_name,
      employee_document_request_created_at:
        data?.employee_document_request_created_at &&
        formatDateOnly(data?.employee_document_request_created_at),
      employee_document_request_updated_at:
        data?.employee_document_request_updated_at &&
        formatDateOnly(data?.employee_document_request_created_at),
      is_document_requested: data?.is_document_requested,
    };
  });

  console.log("documentRequest", documentRequest);

  const handleDownload = async (filePath) => {
    try {
      const a = document.createElement("a");
      a.href = filePath;
      a.target = "_blank";
      // a.download = "policy_document.jpg";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  const columns = [
    {
      title: "#",
      dataIndex: "id",
      sorter: (a, b) => a.id.length - b.id.length,
    },
    {
      title: "Name",
      dataIndex: "name",
      sorter: (a, b) => a.name.length - b.name.length,
    },
    {
      title: "Document Type ",
      dataIndex: "document_value",
      sorter: (a, b) => a.document_value.length - b.document_value.length,
    },

    {
      title: "Requested Document",
      dataIndex: "is_document_requested",
      sorter: (a, b) =>
        a.is_document_requested.length - b.is_document_requested.length,
      render: (record) => (
        <span className={`badge badge-${record == 1 ? "success" : "info"}`}>
          {record == 0 ? "NO" : "YES"}
        </span>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      sorter: (a, b) => a.status.length - b.status.length,
      render: (record) => (
        <span style={{ color: record == "Pending" ? "#ffb41b" : "#1b9928" }}>
          {record}
        </span>
      ),
      // sorter: (a, b) =>
      //   a.status.length - b.status.length,
    },

    {
      title: "Date",
      dataIndex: "employee_document_request_updated_at",
      sorter: (a, b) => a.document_value.length - b.document_value.length,
    },

    {
      title: "Action",
      render: (record) => (
        <div className="dropdown dropdown-action text-end">
          <Link
            to="#"
            className="action-icon dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="material-icons">more_vert</i>
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            {!record?.document_id ||
            record?.visible == 0 ||
            record?.visible == null ? (
              <>
                <Link
                  className="dropdown-item"
                  data-bs-toggle="modal"
                  data-bs-target="#upload_document_modal"
                  to="#"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setEmployeeID(record?.employee_id);
                    setRequestedDocumnetId(record?.requested_document_id);
                  }}
                >
                  <i class="fa-solid fa-upload"></i> Upload
                </Link>
              </>
            ) : (
              <>
                <span
                  className="dropdown-item"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    handleDownload(`${config.IMAGE_URL}${record?.document}`)
                  }
                >
                  <i class="fa-solid fa-eye m-r-5"></i> View
                </span>
                <Link
                  className="dropdown-item"
                  to="#"
                  data-bs-toggle="modal"
                  data-bs-target="#delete"
                  onClick={() => {
                    setDeletedID(record?.my_documents_id);
                    setRequestDocument(record?.is_document_requested);

                    setRequestedDocumnetId(record?.requested_document_id);
                  }}
                >
                  <i className="fa fa-trash m-r-5" /> Delete
                </Link>
              </>
            )}
          </div>
        </div>
      ),
    },
  ];

  const confirmDelete = async () => {
    if (deletedID) {
      try {
        const response = await api.put(
          `hr/delete-documnet/${deletedID}/${requestedDocumnetID}?requestedDocument=${requestedDocument}`
        );
        if (response?.data?.success == true) {
          console.log("deleted successully ");
          fetchRequestedDocument();
        }
      } catch (err) {
        console.log(err);
      }
    }
  };

  const closeUploadDocumentsModal = () => {
    setOpenUploadDocuments(false);
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="Requested Document"
            title={t("Dashboard")}
            subtitle={t("Requested Document")}
            name={t("Upload")}
            openModal={() => setOpenUploadDocuments(true)}
            secondaryName={t("Generate")}
            openSecondaryModal={() => setOpenGenerateDocument(true)}
            page="upload-document"
            action="create"
          />

          <div className="row">
            <div className="col-md-12">
              <div className="table-responsive">
                <Table
                  className="table-striped"
                  style={{ overflowX: "auto" }}
                  columns={columns}
                  dataSource={documentRequest}
                  rowKey={(record) => record?.id}
                  scroll={{ x: true }}
                  tableLayout="auto"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <AddandEditPolicy policy={policyEditData} setPolicyData={setPolicyData} selectedDepartmentId= {selectedDepartmentId} selectedDesignationtId ={selectedDesignationtId}/> */}
      <DeleteModal Name="Delete Policy" confirmDelete={confirmDelete} />
      <UploadDocumnetModal
        requestedDocumnetID={requestedDocumnetID}
        employeeID={employeeID}
        fetchRequestedDocument={fetchRequestedDocument}
      />
      {openUploadDocuments && (
        <UploadDocuments
          show={openUploadDocuments}
          handleClose={closeUploadDocumentsModal}
          employerDocuments={employerDocuments}
          employeeData={employeeData}
          fetchRequestedDocument={fetchRequestedDocument}
        />
      )}
      {openGenerateDocument && (
        <GenerateDocumentModal
          show={openGenerateDocument}
          handleClose={() => setOpenGenerateDocument(false)}
          employeeData={employeeData}
          fetchRequestedDocument={fetchRequestedDocument}
        />
      )}
    </>
  );
};

export default UploadDocumnet;
